import * as React from 'react';
import { RouteComponentProps, withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux'; // Connecting to Redux
import bindAllOfThis from "src/utils/BindThisHelper";
import Routes from 'src/core/Routes';
import MatchmakerForm from './forms/MatchmakerForm';

// Note: RouteComponentProps<{}> MUST be removed if sub-component OR MUST return 'withRouter(LandscapingGame)'
interface MatchmakerProps extends RouteComponentProps<{}> {
}

interface MatchmakerState {
}

class Matchmaker extends React.Component<MatchmakerProps, MatchmakerState> {
    constructor(props: MatchmakerProps) {
        super(props);
        bindAllOfThis(this, Matchmaker.prototype);

        // You are allowed to set defaults here, based on your state object above
        this.state = {
        };
    }

    render() {
        return <div>
            <MatchmakerForm />
        </div>;
    }
}

export default Matchmaker;



// WEBPACK FOOTER //
// ./src/pages/admin/Matchmaker.tsx